var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#216BC4",
    fillRule: "evenodd",
    d: "M8.333 12.196c-.125.29-.194.61-.194.946V17h6.194v-3.858a2.4 2.4 0 0 0-2.395-2.403h-1.404c-.249 0-.489.039-.715.11a.765.765 0 0 0-.4-.113c-1.285 0-2.048-.505-2.492-1.381a3.63 3.63 0 0 1-.33-1.02 2.969 2.969 0 0 1-.048-.434.778.778 0 0 0-.78-.778A.779.779 0 0 0 5 7.91c.003.563.14 1.353.549 2.159.557 1.098 1.481 1.86 2.784 2.127zM11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm-.022-12.304c1.283 0 2.323-1.052 2.323-2.348C13.301 6.05 12.261 5 10.978 5S8.655 6.051 8.655 7.348c0 1.296 1.04 2.348 2.323 2.348z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSource);
export default __webpack_public_path__ + "static/media/source.4cb493416ac082ebaa5cacab0d9b95bc.svg";
export { ForwardRef as ReactComponent };